import React, { useState, useEffect } from "react";
import { isWithinOperatingHours } from '../utils/operatingHours';
import PinModal from './pinModal';

const CallToAction = ({ jsonDiag, diagnosticId }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isOperating, setIsOperating] = useState(false); // State to check operating hours

    const handleChat = () => {
        // Open the custom URL instead of the modal
        const chatUrl = `${process.env.REACT_APP_CHAT_URL}${diagnosticId}`;
        window.location.href = chatUrl;
    };

    useEffect(() => {
        // Call the function to check operating hours
        const checkOperatingHours = () => {
            const withinHours = isWithinOperatingHours();
            setIsOperating(withinHours); // Set the state based on the result
        };

        checkOperatingHours();
    }, []); // Run once on component mount

    return (
        <>
            {isOperating && (
                <div style={{ marginTop: "20px" }}>
                    <button
                        onClick={(e) => {
                            e.preventDefault();
                            handleChat(); // Open the custom URL on click
                        }}
                        style={{ border: 'none', background: 'none', width: '100%', cursor: 'pointer' }}
                    >
                        <img
                            src="/cta.svg"
                            alt="Haz una cita con un Doctor para revisar estos resultados."
                            width="100%"
                        />
                    </button>

                    {/* Pass the apiResponses to PinModal */}
                    <PinModal
                        open={isModalOpen}
                        handleClose={() => setIsModalOpen(false)}
                        jsonDiag={jsonDiag} // Pass the structured API response
                    />
                </div>
            )}
        </>
    );
};

export default CallToAction;
